(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[791,1674],{

/***/ 24683:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/[slug]/[id]",
      function () {
        return __webpack_require__(8846);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _containers_BlogPage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1116);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25291);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68037);







var AdditionalPageContainer = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var advCustomSeo = props.advCustomSeoDetails;
    (0,_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSetSSRStore */ .Vn)(props.ssrStore);
    var storeInfo = (0,_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        store: storeInfo,
        title: (advCustomSeo === null || advCustomSeo === void 0 ? void 0 : (ref = advCustomSeo.title) === null || ref === void 0 ? void 0 : ref.value) || "".concat(props === null || props === void 0 ? void 0 : (ref1 = props._addPage) === null || ref1 === void 0 ? void 0 : ref1.page_name, " - ").concat(storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.store_info) === null || ref2 === void 0 ? void 0 : ref2.name),
        Icon: storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.store_info) === null || ref3 === void 0 ? void 0 : ref3.logo_image,
        metaDescription: (advCustomSeo === null || advCustomSeo === void 0 ? void 0 : advCustomSeo.description) || "Now order online from my whatsapp store & pay using 150+ UPI Apps",
        OGTitle: (advCustomSeo === null || advCustomSeo === void 0 ? void 0 : (ref4 = advCustomSeo.og_title) === null || ref4 === void 0 ? void 0 : ref4.value) || null,
        OGDescription: (advCustomSeo === null || advCustomSeo === void 0 ? void 0 : advCustomSeo.og_description) || null,
        OGImage: storeInfo === null || storeInfo === void 0 ? void 0 : (ref5 = storeInfo.store_info) === null || ref5 === void 0 ? void 0 : ref5.logo_image,
        isCustomDomain: props.isCustomDomain,
        canonicalTagUrl: "".concat(storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_url, "/p/").concat(props === null || props === void 0 ? void 0 : (ref6 = props._addPage) === null || ref6 === void 0 ? void 0 : ref6.slug_url)
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_BlogPage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props))
    }));
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (AdditionalPageContainer);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8388,1562,1033,5291,3978,676,9774,2888,179], function() { return __webpack_exec__(24683); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);